<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_gz.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_gz.png'
import list_img1 from '../../images/download/down-gz1.jpg'
import list_img2 from '../../images/download/down-gz2.jpg'
import list_img3 from '../../images/download/down-gz3.jpg'
import cut_img1 from '../../images/download/gzjt1.jpg'
import cut_img2 from '../../images/download/gzjt2.jpg'
import cut_img3 from '../../images/download/gzjt3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来贵州麻将',
                size:'76.06',
                load_count:'1959',
                desp:'贵阳捉鸡麻将最早起源于“川麻将”。经过创新，增加了“捉鸡”、“通行证”、“金鸡”等特色元素，迅速串红于云、贵、川、附近一带，尤其盛行于贵州省，所以“贵阳川麻将”也叫“贵阳捉鸡麻将”。如今，贵阳捉鸡麻将以其独特的玩法，绝对刺激的游戏规则得到全国各地麻友的推崇！是最具特色的麻将玩法之一！',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=guizhou',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=guizhou',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
